module.exports = __webpack_public_path__ + "static/location-pin-33165f4d7f3deba1e85a720740973513.svg";